import { useEffect, useState } from "react";
import api, { managerApi } from "../services/api";
import ManagerLoginModal from "../components/ManagerLoginModal";

export default function DayEnd() {
  const [locked, setLocked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [locking, setLocking] = useState(false);
  const [showManagerLogin, setShowManagerLogin] = useState(false);

  useEffect(() => {
    checkStatus();
  }, []);

  // ================= CHECK DAY STATUS =================
  const checkStatus = async () => {
    try {
      const res = await api.get("/day-end/status");
      setLocked(res.data.locked);
    } catch {
      alert("Failed to check day status");
    } finally {
      setLoading(false);
    }
  };

  // ================= ACTUAL LOCK API =================
  const performLock = async () => {
    try {
      setLocking(true);
      await managerApi.post("/day-end/lock");
      alert("Day locked successfully");
      setLocked(true);
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        setShowManagerLogin(true);
      } else {
        alert(err.response?.data?.message || "Failed to lock day");
      }
    } finally {
      setLocking(false);
    }
  };

  // ================= BUTTON HANDLER =================
  const lockDay = () => {
    if (!window.confirm("Are you sure you want to lock the day?")) return;
    performLock();
  };

  return (
    <>
      <div style={{ padding: 20 }}>
        <h2>Day End</h2>

        <p>
          <b>Date:</b> {new Date().toLocaleDateString()}
        </p>

        {loading ? (
          <p>Checking status...</p>
        ) : locked ? (
          <p style={{ color: "green", fontSize: 16 }}>
            ✅ Day is already locked
          </p>
        ) : (
          <>
            <p style={{ color: "red", fontSize: 16 }}>
              ⚠ Day not locked
            </p>

            <button
              onClick={lockDay}
              disabled={locking}
              style={{
                padding: "10px 20px",
                background: "#b00020",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: 16
              }}
            >
              {locking ? "Locking..." : "LOCK DAY"}
            </button>
          </>
        )}
      </div>

      {/* MANAGER LOGIN MODAL */}
      {showManagerLogin && (
        <ManagerLoginModal
          onSuccess={() => {
            setShowManagerLogin(false);
            performLock(); // retry AFTER manager auth
          }}
          onClose={() => setShowManagerLogin(false)}
        />
      )}
    </>
  );
}
